<template>
    <div class="borrow">
        <div class="search">
            <Input v-model="search" :placeholder="$t('searchTips')+'...'" style="width:200px;"></Input>
            <DatePicker type="date" v-model="start" placeholder="选择开始日期" style="width: 200px" />
            <DatePicker type="date" v-model="end" placeholder="选择结束日期" style="width: 200px" />
            <Button type="primary" @click="loadData(currentPage)">搜索</Button>
            <Button type="primary" @click="addProduct">添加</Button>
        </div>
        <Table border :columns="columns12" :data="data6" style="width: 100%;">
            <template slot-scope="{ row }" slot="name">
                <strong>{{ row.name }}</strong>
            </template>
        </Table>
        <div class="page">
            <Page
                :total="totalItems"
                :page-size="itemsPerPage"
                show-elevator
                :current="currentPage"
                @on-change="loadData"
            />
        </div>
          
        <Modal v-model="showEditModal" :title="title" @on-ok="editProduct">
            <Form :label-width="80">
                <Form-item label="名称">
                    <Input v-model="modalItem.name" />
                </Form-item>
                <Form-item label="图片">
                    <div class="file_box">
                        <img :src="modalItem.logo || logo" alt v-if="modalItem.logo || logo" />
                        <div class="img" v-show="!modalItem.logo && !logo">
                            <p class="gray_color">{{$t('selectPhoto')}}</p>
                        </div>
                        <input type="file" accept="image/*" @change="get_file($event)" />
                    </div>
                </Form-item>
                <Form-item label="周期">
                    <Input v-model="modalItem.period" type="number"  step="0.01"/>
                </Form-item>
                <Form-item label="赔率">
                    <Input v-model="modalItem.rate" type="number" step="0.01" />
                </Form-item>
                <Form-item label="最低投注">
                    <Input v-model="modalItem.min" type="number" step="0.01" />
                </Form-item>
                <Form-item label="最高投注">
                    <Input v-model="modalItem.max" type="number" step="0.01" />
                </Form-item>
                <Form-item label="开始时间">
                    <DatePicker type="datetime" v-model="modalItem.start_time" placeholder="选择开始日期" style="width: 200px" />
                </Form-item>
                <Form-item label="结束时间">
                    <DatePicker type="datetime" v-model="modalItem.end_time" placeholder="选择结束日期" style="width: 200px" />
                </Form-item>
                <Form-item label="是否热门">
                    <i-switch v-model="modalItem.is_hot" />
                </Form-item>
            </Form>
        </Modal>
        <Modal
            v-model="showDelModal"
            :title="$t('del')"
            @on-ok="delRow(modalItem)"
            @on-cancel="showDelModal=false"
        >
            <p>{{$t('confirmDel')}}</p>
        </Modal>
        
    </div>
</template>
<script>
import { title } from 'echarts/lib/theme/dark.js';
import { formatUTCTime as formatUTC } from '../../common/common.js';
export default {
    data() {
        return {
            modalItem: {},
            showDelModal: false,
            productIdToDel: 0,
            currentPage: 1,
            totalPages: 1,
            itemsPerPage: 10,
            totalItems: 0,
            search: "",
            start:'',
            end:'',
            title: '编辑',
            isAdd: false,
            totalItems: 1,
            img_load: false,
            logo: '',
            showEditModal: false,
            columns12: [
                {
                    title: "ID",
                    width: 60,
                    key: "id",
                },
                {
                    title: "名称",
                    width: 150,
                    key: "name",
                    render: (h, params) => {
                        if (params.row.logo) {
                            return h("div", {style:{display: 'flex', justifyContent: 'center', alignItems: 'center',gap: '5px'}}, [
                                
                                h("img", {src: params.row.logo,
                                    style: {width: '50px',height: '50px',borderRadius: '50%',border: '1px solid #ccc'}
                                }),
                                h("span", {style:{fontSize: '16px',fontWeight: 'bold'}}, params.row.name)
                            ]);
                        } else {
                            return h("span", params.row.name);
                        }
                    }
                },
                {
                    title: "周期",
                    width: 120,
                    key: "period",
                },

                {
                    title: "赔率",
                    width: 100,
                    key: "rate",
                },
                {
                    title: "最低投注",
                    width: 130,
                    key: "min"
                },
                {
                    title: "最高投注",
                    width: 100,
                    key: "max"
                },

                {
                    title: "开始时间",
                    width: 110,
                    key: "start_time"
                },
                {
                    title: "结束时间",
                    width: 150,
                    key: "end_time"
                },
                {
                    title: this.$i18n.t('status'),
                    width: 110,
                    key: "status",
                    render: (h, params) => {
                        if (params.row.status == 0) {
                            return h("div", [
                                h("Icon", {
                                    props: {
                                        type: 'md-close',
                                        size: 24,
                                        color: 'red'
                                    },
                                    on: {
                                        click: () => {
                                            this.edit_status(params.row, 0)
                                        }
                                    }
                                }, '禁用')
                            ])
                        } else {
                            return h("div", [
                                h("Icon", {
                                    props: {
                                        type: 'md-checkmark',
                                        size: 24,
                                        color: 'green'
                                    },
                                    on: {
                                        click: () => {
                                            this.edit_status(params.row, 1)
                                        }
                                    }
                                }, '启用')
                            ])
                        }
                    }
                },

                {
                    title:this.$i18n.t('action'),
                    width: 110,
                    align: 'center',
                    key: "action",
                    render: (h, params) => {
                        return h("div",{style:{display: 'flex', flexDirection: 'row', justifyContent: 'center',alignItems: 'center',gap: '5px'}}, [
                            h("Icon", {
                                props: {
                                    type: 'md-eye',
                                    size: 24,
                                    color: 'white'
                                },
                                style: {
                                    backgroundColor: 'green',
                                    border: 'none',
                                },
                                on: {
                                    click: () => {
                                        this.viewHistory(params.row.id)
                                    }
                                }
                            }),
                            h("Icon", {
                                props: {
                                    type: 'md-create',
                                    size: 24,
                                    color: 'white'
                                },
                                style: {
                                    backgroundColor: 'blue',
                                    border: 'none',
                                },
                                on: {
                                    click: () => {
                                        this.editModal(params.row)
                                    }
                                }
                            }),
                            h("Icon", {
                                props: {
                                    type: 'md-trash',
                                    size: 24,
                                    color: 'white'
                                },
                                style: {
                                    backgroundColor: 'red',
                                    border: 'none',
                                },
                                on: {
                                    click: () => {
                                        this.delRow(params.row)
                                    }
                                }
                            })
                        ]);
                    }
                }
            ],
            data6: []
        };
    },
    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(page) {
            this.currentPage = page;
            this.$get(this.$path.product_list, {
                page: this.currentPage,
                search: this.search,
                start: this.start,
                end: this.end
            }).then(res => {
                if (res.errcode == 0) {
                    this.data6 = res.data.list;
                    this.totalItems = res.data.pageObj.totalSize;
                    this.itemsPerPage = res.data.pageObj.pageSize;
                } else {
                    this.$Message.error(this.$i18n.t('dataFailed'));
                }
            });
        },
        viewHistory(id) {
            this.$router.push({
                name: "history",
                query: {
                    id: id
                }
            });
        },
        addProduct() {
            this.modalItem = {};
            this.logo = '';
            this.title = '添加';
            this.showEditModal = true;
            this.isAdd = true;
        },
        showUserDetail(user_id) {
            this.$router.push({
                name: "user_detail",
                query: {
                    user_id: user_id
                }
            });
        },
        editModal(row) {
            
            this.logo = row.logo || '';
            
            this.modalItem.start_time = row.start_time || '';
            this.modalItem.end_time = row.end_time || '';
            this.modalItem.id = row.id;
            this.modalItem.name = row.name;
            this.modalItem.period = row.period;
            this.modalItem.rate = row.rate;
            this.modalItem.min = row.min;
            this.modalItem.max = row.max;
            this.modalItem.is_hot = row.is_hot;
            this.modalItem.status = row.status;
            this.isAdd = false; 
            this.showEditModal = true;
        },
        get_file(e) {
            this.img_load = true;
            let formData = new FormData();
            formData.append("img", e.currentTarget.files[0]);
            this.$file(this.$path.upload, formData)
                .then(res => {
                    this.img_load = false;
                    const path = res.data.path;
                    this.logo = path;
                    this.modalItem.logo = path;
                })
                .catch(err => {
                    this.img_load = false;
                }).finally(() => {
                    this.img_load = false;
                    this.modalItem.logo = this.logo;
                });
        },
        delRow(row) {
            this.productIdToDel = row.id;
            this.showDelModal = true;
        },
        delRowOk() {
            this.$post(this.$path.product_del, {
                id: this.productIdToDel
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                    this.showDelModal = false;
                    this.productIdToDel = 0;
                } else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
            });
        },
        delModal(row) {
            this.modalItem = row;
            this.showDelModal = true;
        },
        change_status(row) {
            this.modalItem = row;
            this.change_sts = true;
            this.$get(this.$path.change_status).then(res => {
                if (res.success) {
                    this.status_data = res.data;
                }
            });
        },
       
        
        edit_status(row,status) {
            this.$post(this.$path.change_status, {
                order_id: row.id,
                status: status,
                user_id: row.user_id,
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                }
            });
        },
        editProduct() {
            console.log(this.modalItem.start_time);
            console.log(this.modalItem.end_time);
            // 只提取时间部分（HH:mm:ss）
            if (this.modalItem.start_time) {
                if (this.modalItem.start_time instanceof Date) {
                    // Date 对象：直接提取时间部分
                    const hours = String(this.modalItem.start_time.getHours()).padStart(2, '0');
                    const minutes = String(this.modalItem.start_time.getMinutes()).padStart(2, '0');
                    const seconds = String(this.modalItem.start_time.getSeconds()).padStart(2, '0');
                    this.modalItem.start_time = `${hours}:${minutes}:${seconds}`;
                } else if (typeof this.modalItem.start_time === 'string') {
                    // 字符串：检查是否已经是时间格式（HH:mm:ss）
                    const timePattern = /^\d{2}:\d{2}:\d{2}$/;
                    if (timePattern.test(this.modalItem.start_time)) {
                        // 已经是时间格式，直接使用
                        // 不做任何处理
                    } else {
                        // 需要格式化
                        const formatted = formatUTC(this.modalItem.start_time, 8, 'HH:mm:ss');
                        this.modalItem.start_time = formatted || this.modalItem.start_time;
                    }
                }
            }
            if (this.modalItem.end_time) {
                if (this.modalItem.end_time instanceof Date) {
                    // Date 对象：直接提取时间部分
                    const hours = String(this.modalItem.end_time.getHours()).padStart(2, '0');
                    const minutes = String(this.modalItem.end_time.getMinutes()).padStart(2, '0');
                    const seconds = String(this.modalItem.end_time.getSeconds()).padStart(2, '0');
                    this.modalItem.end_time = `${hours}:${minutes}:${seconds}`;
                } else if (typeof this.modalItem.end_time === 'string') {
                    // 字符串：检查是否已经是时间格式（HH:mm:ss）
                    const timePattern = /^\d{2}:\d{2}:\d{2}$/;
                    if (timePattern.test(this.modalItem.end_time)) {
                        // 已经是时间格式，直接使用
                        // 不做任何处理
                    } else {
                        // 需要格式化
                        const formatted = formatUTC(this.modalItem.end_time, 8, 'HH:mm:ss');
                        this.modalItem.end_time = formatted || this.modalItem.end_time;
                    }
                }
            }
            console.log( 'start_time', this.modalItem.start_time);
            console.log( 'end_time', this.modalItem.end_time);
            // 创建数据副本，避免响应式问题
            const postData = JSON.parse(JSON.stringify(this.modalItem));
            console.log('发送的数据:', postData);
            this.$post(this.isAdd ? this.$path.product_add : this.$path.product_edit, postData).then(res => {
                if (res.errcode == 0) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                } else {
                    this.$Message.error(res.error);
                }
            }).finally(() => {
                this.showEditModal = false;
                this.modalItem = {};
                this.title = '编辑';
                this.isAdd = false;
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.search {
    margin-bottom: 20px;
}
.page {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
.jt_img {
    width: 100%;
    img {
        width: 100%;
    }
}
.order_num {
    display: flex;
    flex-direction: row;
    .tit {
        width: 60px;
        color: #bab9b9;
    }
    .info {
        width: 200px;
    }
}
.sts_list {
    margin-top: 10px;
    .tit {
        width: 100px;
        color: #bab9b9;
    }
}
.op_btn {
    margin-top: 5px;
}
.op_btn:nth-child(2) {
    margin-bottom: 5px;
}
/*.radio_div {
     width: 25%; 
}*/
.ivu-radio-group {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
.red_color{
    color: red;
}
.file_box {
        display: flex;
        flex-direction: column;
        width: 200px;
        height: 170px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border: 1px #eeeeee dashed;
        border-radius: 4px;
        margin-right: 20px;
        .show_big_img {
            width: 100%;
            height: 20px;
            cursor: pointer;
            text-align: center;
        }
        img {
            width: 100%;
            height: 130px;
        }
        .img {
            width: 100%;
            height: 100%;

            p {
                text-align: center;
                color: #bab9b9;
                // margin-top: 20px;
            }
        }
        input {
            position: absolute;
            top: 0;
            left: 0;
            width: 200px;
            height: 150px;
            opacity: 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/product/manage.vue